const {KitModule, registerModule} = window;

class ScrollGraphic extends KitModule {
  constructor($element) {
    super($element);
    this.activeIndex = -1;
  }

  onInitialize() {
    this.icons = this.$element.querySelectorAll('.scrollGraphic__icon-point');
    this.itemCount = this.icons.length;
    this.stickyContainer = this.$element.querySelector('.scrollGraphic__sticky-container');

    this.init();
  }

  init() {
    // Bind scroll event
    this.boundOnScroll = this.onScroll.bind(this);
    window.addEventListener('scroll', this.boundOnScroll, {passive: true});

    // Bind resize
    window.addEventListener('resize', () => {
      this.onScroll();
    }, {passive: true});

    // Force run once
    this.onScroll();
  }

  onScroll() {
    if (!this.stickyContainer) return;

    const rect = this.$element.getBoundingClientRect();
    const stickyHeight = this.stickyContainer.offsetHeight; // Should be viewport height
    const sectionHeight = rect.height;

    // Calculate scrollable distance
    // The animation happens while the section is sticky.
    // Start: rect.top <= 0
    // End: rect.bottom <= stickyHeight

    // Safety check divison by zero if heights are equal
    const scrollableDistance = sectionHeight - stickyHeight;

    if (scrollableDistance <= 10) {
      this.setActive(0);
      return;
    }

    const scrolled = -rect.top;

    // Progress 0 to 1
    let progress = scrolled / scrollableDistance;
    progress = Math.max(0, Math.min(1, progress));

    // Map to index
    const index = Math.min(
      Math.floor(progress * this.itemCount),
      this.itemCount - 1,
    );

    if (this.activeIndex !== index) {
      this.activeIndex = index;
      this.setActive(index);
    }
  }

  setActive(index) {
    if (index < 0) index = 0;

    // Update Icons (which now contain the description text)
    this.icons.forEach((icon, i) => {
      if (i === index) {
        icon.classList.add('is-active');
      } else {
        icon.classList.remove('is-active');
      }
    });
  }
}

registerModule('ScrollGraphic', ScrollGraphic);
